import Vuex from "vuex";
import { createSyncHandler } from "./createSyncHandler";
import { fetchHil } from "../utils";
import * as _ from "lodash";

const QUERIES = {};

let NEXT_QUERY = 1;

export default {
  namespaced: true,
  state: {
    all: [],
    filtered: [],
    current: null,
  },
  mutations: {
    reset(state) {
      state.all = [];
      state.filtered = [];
    },

    setAnnouncements(state, { announcements, reset, search }) {
      if (announcements != null) {
        if (reset) {
          state.all = announcements;
        } else {
          state.all = [...state.all, ...announcements];
        }
      }
      state.filtered = state.all.filter((prj) => {
        if (search !== "") {
          return (
            prj._id.includes(search) ||
            prj.title?.toLowerCase().includes(search) ||
            prj.url?.toLowerCase().includes(search)
          );
        }
        return true;
      });
    },

    setAnnouncement(state, announcement) {
      state.current = _.cloneDeep(announcement);
      state.previous = _.cloneDeep(announcement);
    },

    setSyncResults(state, { resp: announcement, updatedKeys }) {
      state.previous = _.cloneDeep(announcement);
    },
  },
  actions: {
    async reset({ commit }) {
      commit("reset");
    },

    async list({ commit }, search = "") {
      const per = 200;
      let count = 0;

      Object.keys(QUERIES).forEach((k) => delete QUERIES[k]);

      const qid = NEXT_QUERY++;
      QUERIES[qid] = true;

      let f = async () => {
        if (!QUERIES[qid]) {
          return;
        }

        const resp = await (
          await fetchHil(
            `/announcements?search=${search}&offset=${count}&size=${per}`,
            {
              method: "GET",
            }
          )
        ).json();

        if (!QUERIES[qid]) {
          return;
        }

        if (resp.length === 0) {
          delete QUERIES[qid];
          return;
        }
        commit("setAnnouncements", {
          announcements: resp,
          search,
          reset: count === 0,
        });
        if (resp.length === 0) {
          delete QUERIES[qid];
          return;
        }
        count += per;
        f();
      };

      f();
    },

    async filter({ commit }, search) {
      commit("setAnnouncements", { announcements: null, search });
    },

    async fetchAnnouncement({ commit, dispatch }, { id }) {
      const resp = await (await fetchHil(`/announcements/${id}`)).json();
      await commit("setAnnouncement", resp);
    },

    syncAnnouncement: createSyncHandler(
      (state) => `/announcements/${state.current._id}`,
      "setSyncResults",
      ["_id", "modelVersion", "stats", "progress", "__v"]
    ),
  },
};
